import types from './constants';

export function openPreviewDialog() {
    return function (dispatch) {
        dispatch({type: types.EXERCISE_BENCHMARK_OPEN_PREVIEW_DIALOG});
    }
}

export function closePreviewDialog() {
    return function(dispatch) {
        dispatch({type: types.EXERCISE_BENCHMARK_CLOSE_PREVIEW_DIALOG})
    }
}

export function openPreviewSingleDialog(benchmark) {
    return function (dispatch) {
        dispatch({type: types.EXERCISE_BENCHMARK_OPEN_PREVIEW_SINGLE_DIALOG, payload: benchmark});
    }
}

export function closePreviewSingleDialog() {
    return function(dispatch) {
        dispatch({type: types.EXERCISE_BENCHMARK_CLOSE_PREVIEW_SINGLE_DIALOG})
    }
}

export function openCreateDialog() {
    return function(dispatch) {
        dispatch({type: types.EXERCISE_BENCHMARK_OPEN_CREATE_DIALOG})
    }
}

export function closeCreateDialog() {
    return function(dispatch) {
        dispatch({type: types.EXERCISE_BENCHMARK_CLOSE_CREATE_DIALOG})
    }
}

export function openCreateBenchmarkFromCopyDialog() {
    return function(dispatch) {
        dispatch({type: types.EXERCISE_BENCHMARK_OPEN_CREATE_FROM_COPY_DIALOG})
    }
}

export function openEditDialog() {
    return function(dispatch) {
        dispatch({type: types.EXERCISE_BENCHMARK_OPEN_EDIT_DIALOG})
    }
}

export function closeEditDialog() {
    return function(dispatch) {
        dispatch({type: types.EXERCISE_BENCHMARK_CLOSE_EDIT_DIALOG})
    }
}

export function openEditContributionDialog() {
    return function(dispatch) {
        dispatch({type: types.EXERCISE_BENCHMARK_OPEN_EDIT_CONTRIBUTION_DIALOG})
    }
}

export function closeEditContributionDialog() {
    return function(dispatch) {
        dispatch({type: types.EXERCISE_BENCHMARK_CLOSE_EDIT_CONTRIBUTION_DIALOG})
    }
}

export function closeCreateBenchmarkFromCopyDialog() {
    return function(dispatch) {
        dispatch({type: types.EXERCISE_BENCHMARK_CLOSE_CREATE_FROM_COPY_DIALOG})
    }
}

export function setBenchmarks(data) {
    return function(dispatch) {
        dispatch({type: types.EXERCISE_BENCHMARK_SET_BENCHMARKS, payload: data});
    }
}

export function addBenchmark(data) {
    return function(dispatch) {
        dispatch({type: types.EXERCISE_BENCHMARK_ADD_BENCHMARK, payload: data});
    }
}

export function editBenchmark(id, data) {
    return function(dispatch) {
        dispatch({type: types.EXERCISE_BENCHMARK_EDIT_BENCHMARK, payload: { id, data }})
    }
}

export function openContributeBenchmarkDialog() {
    return function(dispatch) {
        dispatch({type: types.EXERCISE_BENCHMARK_OPEN_CONTRIBUTE_DIALOG});
    }
}

export function closeContributeBenchmarkDialog() {
    return function(dispatch) {
        dispatch({type: types.EXERCISE_BENCHMARK_CLOSE_CONTRIBUTE_DIALOG});
    }
}

export function deleteBenchmark(id) {
    return function(dispatch) {
        dispatch({type: types.EXERCISE_BENCHMARK_DELETE_BENCHMARK, payload: id})
    }
}

export function addToCurrentBenchmarks(benchmark) {
    return function(dispatch) {
        dispatch({type: types.EXERCISE_BENCHMARK_ADD_TO_CURRENT_BENCHMARKS, payload: benchmark});
    }
}

export function removeFromCurrentBenchmarks(benchmark) {
    return function(dispatch) {
        dispatch({type: types.EXERCISE_BENCHMARK_REMOVE_FROM_CURRENT_BENCHMARKS, payload: benchmark});
    }
}